/** ai 作品 */
import React, { useState } from 'react'
import styles from './AiArtworks.module.css'
import { MyTab, CateDataProps } from '~/components/ui/MyTab'
import { GET_PRODUCT_LIST } from '~/graphqls/gqls'
import {
  getProductList,
  getProductList_itemModule_productList_edges_node,
  ArtworkSortEnum,
  SortType,
  ArtworkDBType,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { SingleProduct } from '~/components/business/SingleProduct'
import { MyEmpty } from '~/components/ui/MyEmpty'
import { getGraphData } from '~/utils'

const AiArtworks: React.FC<{
  categoryList: any[]
  aiArtworks: any[]
}> = ({ categoryList, aiArtworks: _aiArtworks }) => {
  const [currentCateIndex, setCateIndex] = useState(0)
  const [aiArtworks, setAiArtworks] = useState(_aiArtworks)
  const queryArtworks = useImperativeQuery<getProductList>(GET_PRODUCT_LIST)

  const getArtworks = (currentCateIndex: number) => {
    const paramSubCateIds = () => {
      // 全部
      if (currentCateIndex === 0) {
        return null
      }
      return [categoryList[currentCateIndex]?.id]
    }
    queryArtworks({
      offset: 0,
      first: 8,
      params: {
        categoryIdList: paramSubCateIds(),
        sortField: ArtworkSortEnum.VERIFY_TIME,
        sort: SortType.DESC,
        type: ArtworkDBType.AI_COPYRIGHT,
      },
    }).then(productRes => {
      setAiArtworks(
        getGraphData(productRes?.data?.itemModule?.productList?.edges || [])
      )
    })
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.orderTabs}>
        <MyTab
          menu={categoryList}
          active={currentCateIndex}
          onChange={key => {
            setCateIndex(+key)
            getArtworks(+key)
          }}
          hideSubMenu
          hideBorder
        />
      </div>
      <div className="flex flex-wrap">
        {aiArtworks?.map(item => (
          <div key={item.id} className="w-1/4 pr-3">
            <SingleProduct data={item} type="aiArtwork" />
          </div>
        ))}
        {!aiArtworks?.length && (
          <MyEmpty
            style={{ margin: '0 auto', padding: '20px 0' }}
            description="暂无作品"
            image="/images/empty-product@2x.png"
          />
        )}
      </div>
    </div>
  )
}
export default AiArtworks
